import React, { useRef, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import BackToTopAnthor from '../components/BackToTopAnthor';
import TitleAnchor from '../components/TitleAnchor';
import PremiumTitle from '../components/PremiumTitle';
import StipendSection from '../components/StipendSection';
import CatalogBenefitSection from '../components/CatalogBenefitSection';
import GameBenefitSection from '../components/GameBenefitSection';
import DiscountAndTrade from '../components/DiscountAndTrade';
import SubscriptionCardContainer from './SubscriptionCardContainer';
import PremiumConstants from '../constants/PremiumConstants';
import PremiumService from '../services/premiumService';

function SubscriptionPageBase({ translate, intl }) {
  const containerBaseRef = useRef(null);
  const [subProducts, setSubProducts] = useState(null);
  const [userPlan, setUserPlan] = useState(null);
  const [showTitleAnchor, setShowTitleAnchor] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  function showError(error) {
    console.log(error);
  }

  function getSearchParams() {
    const queryParams = new Map();
    window.location.search
      .substr(1)
      .split('&')
      .forEach(function parseQuery(query) {
        const param = query.split('=');
        const key = param[0];
        let value = decodeURIComponent(param[1]);
        value = Number.isNaN(Number(value)) ? value : Number(value);
        queryParams.set(key, value);
      });
    return queryParams;
  }

  useEffect(() => {
    function feedProducts(oldProducts) {
      if (!oldProducts || oldProducts.length <= 0) {
        return;
      }

      const newProducts = [];
      oldProducts.forEach(product => {
        const tempProduct = { ...product };
        tempProduct.isRecurring =
          product.subscriptionTypeName.toLowerCase().indexOf('onemonth') < 0;
        newProducts.push(tempProduct);
      });
      setSubProducts(newProducts);
    }

    function sendImpression() {
      const urlParams = getSearchParams();
      const targetType = urlParams.get('upsellTargetType');
      if (!targetType) {
        return;
      }
      const targetId = urlParams.get('upsellTargetId');
      if (!targetId) {
        return;
      }
      const context = urlParams.get('ctx');
      if (!context) {
        return;
      }

      PremiumService.sendPremiumUpsellImpression(context, targetType, targetId).then(
        function success() {},
        function error() {}
      );
    }

    PremiumService.getSubscriptionPlans({
      typeName: PremiumConstants.premiumFeatureType.subscription
    }).then(
      result => {
        if (result?.data) {
          feedProducts(result.data.products);
        } else {
          showError({ errorCode: PremiumConstants.errorCodes.productsNotFound });
        }
      },
      error => {
        showError(error);
      }
    );

    PremiumService.getUserPremiumStatus().then(response => {
      setUserPlan(response.data?.subscriptionProductModel);
    });
    sendImpression();
  }, []);

  const handleScroll = useCallback(() => {
    const { scrollY: scrollPosition } = window;
    if (scrollPosition > 500 && scrollPosition < 2800) {
      setShowTitleAnchor(true);
    } else {
      setShowTitleAnchor(false);
    }

    if (scrollPosition > 500) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  }, []);

  useEffect(() => {
    // register scroll handler
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    if (userPlan) {
      const pageElement = document.getElementById('premium-memberships');
      pageElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, [userPlan]);

  return (
    <div
      className='subscription-container-base'
      id='subscription-container-base'
      ref={containerBaseRef}>
      {!userPlan && (
        <TitleAnchor translate={translate} userPlan={userPlan} isShown={showTitleAnchor} />
      )}
      <BackToTopAnthor isShown={showBackToTop} />
      <PremiumTitle translate={translate} isPremiumUser={!!userPlan} id='premium-title' />
      <StipendSection translate={translate} planInfo={subProducts} />
      <CatalogBenefitSection translate={translate} />
      <GameBenefitSection translate={translate} />
      <DiscountAndTrade translate={translate} />
      <SubscriptionCardContainer
        translate={translate}
        intl={intl}
        planInfo={subProducts}
        userPlan={userPlan}
      />
    </div>
  );
}
SubscriptionPageBase.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    d: PropTypes.func.isRequired
  }).isRequired
};
export default SubscriptionPageBase;
